import { gql, useMutation } from '@apollo/client'
import { GetAccount } from '~publish/contexts/AccountContext'

const ACCOUNT_SET_SETTINGS = gql`
  mutation accountSetSettings($settings: SettingsInput!) {
    accountSetSettings(settings: $settings) {
      ... on AccountSetSettingsResponse {
        success
        settings {
          aiSettings {
            onboarded
          }
        }
      }
      ... on AccountSetSettingsError {
        userFriendlyMessage
        cause
      }
    }
  }
`

export const useAccountSetSettings = () => {
  const [
    accountSetSettings,
    {
      data: accountSetSettingsData,
      error: accountSetSettingsError,
      loading: accountSetSettingsLoading,
    },
  ] = useMutation(ACCOUNT_SET_SETTINGS, {
    refetchQueries: [GetAccount],
  })

  return {
    accountSetSettings,
    accountSetSettingsData,
    accountSetSettingsError,
    accountSetSettingsLoading,
  }
}
